import api from "../api";

export default {
    index({ params } = {}) {
        return api.get(`/merchant/credits`, { params })
    }
}
